import { parseNodeDataWithSchema, type ParsedNodeData } from '@cotera/api';
import type { z } from 'zod';
import { WorkflowNode } from '../workflow-node-base';

/**
 * A node whose `data` has a schema in `@cotera/api`. Parsing is lazy and never
 * throws: the canvas, run view, copy and cancel paths all need to load nodes
 * whose stored data no longer matches, so only execution should insist on
 * `valid`.
 */
export abstract class TypedWorkflowNode<
  S extends z.ZodType
> extends WorkflowNode {
  protected abstract readonly schema: S;
  private parsed: ParsedNodeData<z.output<S>> | undefined;

  get parsedData(): ParsedNodeData<z.output<S>> {
    if (this.parsed === undefined) {
      this.parsed = parseNodeDataWithSchema(this.schema, this._data.data);
    }
    return this.parsed;
  }

  /** Parsed data, or null when the stored data doesn't match the schema. */
  get config(): z.output<S> | null {
    const parsed = this.parsedData;
    return parsed.t === 'valid' ? parsed.data : null;
  }
}
